<template>
  <div>
    <div>
      <h2>Generate players</h2>

      <p class="mb-2">
        For feature testing purposes, you can ask server to generate fake sequence stats.
      </p>

      <p class="alert alert-warning">
        NOTE: This feature only available when property IS_DEV is enabled.
      </p>

      <form @submit.prevent="generateStatsWithConfirmation">
        <div class="form-group row">
          <label class="col-md-4 col-form-label" for="amount">Sequence</label>
          <div class="col-md-8">
            <b-form-select
                id="sequence"
                v-model="sequence"
                :options="sequences"
            />
          </div>
        </div>

        <div class="form-group row">
          <label class="col-md-4 col-form-label" for="minValue">Min value</label>
          <div class="col-md-8">
            <input v-model.number="minValue" id="minValue" class="form-control" type="number" min="0" step="0.01">
          </div>
        </div>

        <div class="form-group row">
          <label class="col-md-4 col-form-label" for="maxValue">Max value</label>
          <div class="col-md-8">
            <input v-model.number="maxValue" id="maxValue" class="form-control" type="number" min="0" step="0.01">
          </div>
        </div>

        <div class="form-group row">
          <label class="col-md-4 col-form-label" for="minPlayers">Min players</label>
          <div class="col-md-8">
            <input v-model.number="minPlayers" id="minPlayers" class="form-control" type="number" min="0">
          </div>
        </div>

        <div class="form-group row">
          <label class="col-md-4 col-form-label" for="maxPlayers">Max players</label>
          <div class="col-md-8">
            <input v-model.number="maxPlayers" id="maxPlayers" class="form-control" type="number" min="0">
          </div>
        </div>

        <hr>

        <b-button class="offset-md-4" type="submit" variant="primary">Generate</b-button>

      </form>
    </div>
  </div>
</template>

<script>
import notifier from "@/notifier";
import {confirmAction} from "@/service/confirm";
import {HTTP} from "@/http-common";

const MAIN_SEQUENCE = 0;
const HIGH_SOCIETY = 1;

const sequences = [
  {
    value: MAIN_SEQUENCE,
    text: 'Main sequence'
  },
  {
    value: HIGH_SOCIETY,
    text: 'High society'
  },
];

export default {
  name: 'DevGenerateStats',

  data() {
    return {
      sequences: sequences,

      sequence: MAIN_SEQUENCE,
      minValue: 0.5,
      maxValue: 5,

      minPlayers: 50,
      maxPlayers: 1000
    };
  },

  methods: {
    generateStatsWithConfirmation() {
      notifier.deleteSenderNotifications(this);

      this.confirmStatsGeneration(() => {
        this.generateStats();
      });
    },

    confirmStatsGeneration(onConfirmed) {
      confirmAction(
          this,
          `Are you sure you want to generate stats?`,
          'Generate',
          onConfirmed,
      );
    },

    generateStats() {
      const data = new FormData();
      data.set('sequence', this.sequence);
      data.set('min_value', this.minValue);
      data.set('max_value', this.maxValue);
      data.set('min_players', this.minPlayers);
      data.set('max_players', this.maxPlayers);

      HTTP.post('/river_rumble/generate_stats', data)
          .then(response => {
            const result = response.data.result;

            const RESULT_SUCCESS = 1;
            if (result.code === RESULT_SUCCESS) {
              notifier.showSuccessAfterTransition('Stats generated.');
              return;
            }

            notifier.showError(result.message, {sender: this});
          })
          .catch(e => {
            notifier.showError(e, {sender: this});
          });
    },
  }
}
</script>
